import React, { useCallback } from 'react';
import { ChevronRightIcon as ChevronRight } from '../../../../icons';

export interface OverviewKpiCardProps {
  icon: React.ComponentType<{ size?: number; className?: string }>;
  label: string;
  value: string;
  repAnchorId?: string;
}

export function OverviewKpiCard({ icon: Icon, label, value, repAnchorId }: OverviewKpiCardProps) {
  const handleScrollToHistory = useCallback(() => {
    if (!repAnchorId) return;
    document.getElementById(repAnchorId)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, [repAnchorId]);

  return (
    <div className="flex flex-col gap-2 rounded-xl border border-[#E5E5E5] bg-white p-4">
      <div className="flex items-start justify-between">
        <Icon size={16} className="text-[#737373]" />
        {repAnchorId && (
          <button
            type="button"
            aria-label={`View ${label} history`}
            onClick={handleScrollToHistory}
            className="text-[#A3A3A3] transition-colors hover:text-[#171717]"
          >
            <ChevronRight size={16} />
          </button>
        )}
      </div>
      <div className="text-caption-medium leading-none text-[#737373]">{label}</div>
      <div className="text-heading-h5 leading-none text-[#171717]">{value}</div>
    </div>
  );
}
